import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { componentSystemHistoryEndPoints } from "../../../services/service-constants";
import { getComponentSystemHistoryTableData } from "../api";
import Pagination from "../../common/Pagination";
import "./index.scss";
import { useLocation } from "react-router";

const ComponentSystemHistoryServiceConditions = () => {
    const location = useLocation();
    const [initialTableData, setInitialTableData] = useState(null);

    const [currentPage, setCurrentPage] = useState();

    const [isPageFirst, setIsPageFirst] = useState(false);

    const [isPageLast, setIsPageLast] = useState(false);

    const [noDataFound, setNoDataFound] = useState(false);

    const vin_Number = useSelector((state) => state.mainReducer.vin_Number);
    
    const [pagenation, setPagenation] = useState({
        totalpages: 0,
        size: 0,
        currentPageNo: 0,
    });

    const onPageChanged = (val) => {
        const nextPage = val;
        getInitialData({
            page: nextPage,
        });
    };

      const getInitialData = async (payload) => {
        const { page, vinNumber, subSystem, statsDate } = payload;
        const data = await getComponentSystemHistoryTableData({
          page: page,
          url: `${componentSystemHistoryEndPoints.service_conditions}`,
          vinNumber:vinNumber,
          subSystem: subSystem,
          statsDate: statsDate || "2022-07-04"
        });
        if (data?.type !== 'error') {
          setNoDataFound(false);
          setInitialTableData(data?.content);
          setCurrentPage(data?.pageable?.pageNumber);
          setIsPageFirst(data?.first);
          setIsPageLast(data?.last);
          setPagenation({
            totalpages: data?.totalPages,
            size: data?.size,
            currentPageNo: data?.pageable?.pageNumber,
          });
        } else {
          setNoDataFound(true);
        }
      };

    useEffect(() => {
        if (location?.state?.subSystem && location?.state?.date) {
            getInitialData({
                page: 0,
                vinNumber:vin_Number,
                subSystem: location.state.subSystem,
                statsDate: location.state.date
            });
        } else {
            setNoDataFound(true);
        }
    }, []);

    return(
        <>
            {noDataFound && <div className="no-data-found"> No Data Found </div>}
            {!noDataFound && 
                <> 
                    <table className="component-system-history-service-conditions-table">
                        <thead>
                            <tr>
                                <th>Service Conditions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {initialTableData?.length &&
                            initialTableData.map((item, index) => (
                                <tr key={index}>
                                    <td>{item?.description || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {pagenation.totalpages > 1 && (
                        <div className="pagination-container">
                        <Pagination
                            pageCount={pagenation.totalpages}
                            pageRange={pagenation.size}
                            onPageChanged={onPageChanged}
                        />
                        </div>
                    )}
                </>
            }
        </>
    )
};

export default ComponentSystemHistoryServiceConditions;
